import { browserFileDownload } from '@/utils';
import { flippoClient } from '@/core';
import { notify } from '@/components';

const fetchBlob = async (reference: string) => {
  try {
    const blob = await flippoClient.fetch(reference);
    return blob;
  } catch {
    return null;
  }
};

export const downloadReport = async (reference: string, name: string, hideForm: () => void) => {
  const reportBlob = await fetchBlob(reference);

  if (reportBlob) {
    browserFileDownload({ blob: reportBlob, fileName: name });
    notify.success.t('projects.project.report.success', { reportName: name });
    hideForm();
  } else {
    notify.error('File not found');
  }
};
